import { render, staticRenderFns } from "./tbfx3.vue?vue&type=template&id=5ece1ec8"
import script from "./tbfx3.vue?vue&type=script&lang=js"
export * from "./tbfx3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports